import React, { useState } from 'react';
import SponsorsContactBg from '../../images/sponsors_contact.webp';
import { addSponsor } from '../../services/sponsors';

function SponsorsContact() {
  const [showPopup, setShowPopup] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    comments: '',
  });

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await addSponsor(formData);
    setShowPopup(false); 
  };

  return (
    <div className="relative flex flex-col md:flex-row h-screen">
      <div className="relative z-10 flex flex-col justify-center p-8 md:px-16 bg-mainBlue w-full md:w-5/12 min-h-[60vh] md:min-h-0">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 md:mb-8">
          Be part of the change
        </h1>
        <p className="text-base md:text-lg lg:text-xl text-white mb-4 md:mb-6">
          Partnering with us means gaining visibility in major events and academic platforms, while contributing to innovation, sustainability, and the education of future engineers.
        </p>
        <p className="text-base md:text-lg lg:text-xl text-white mb-6 md:mb-8">
          Want to help? Find out how you can contribute to our journey.
        </p>
        <button
          onClick={togglePopup}
          className="bg-white text-mainBlue font-bold text-base md:text-lg px-6 md:px-8 py-2 md:py-3 rounded-full hover:bg-gray-100 transition duration-300 w-fit flex items-center gap-2"
        >
          Contact us
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-4 h-4">
            <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
          </svg>
        </button>
      </div>
      <div className="w-full md:w-7/12 h-[40vh] md:h-full">
        <img src={SponsorsContactBg} alt="background" className="h-full w-full object-cover md:object-right object-center" />
      </div>

      {/* Popup */}
      {showPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white rounded-lg p-8 w-[90%] md:w-[50%] shadow-lg relative">
            <button
              onClick={togglePopup}
              className="absolute top-4 right-4 text-gray-500 hover:text-gray-800 text-xl"
            >
              &times;
            </button>
            <h2 className="text-2xl font-bold text-mainBlue mb-4">Contact Form</h2>
            <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                className="border border-gray-300 rounded-lg p-3 w-full"
                value={formData.name}
                onChange={handleChange}
                required
              />
              <input
                type="email"
                name="email"
                placeholder="Your Email"
                className="border border-gray-300 rounded-lg p-3 w-full"
                value={formData.email}
                onChange={handleChange}
                required
              />
              <input
                type="text"
                name="phone"
                placeholder="Mobile Phone (Optional)"
                className="border border-gray-300 rounded-lg p-3 w-full"
                value={formData.phone}
                onChange={handleChange}
              />
              <input
                type="text"
                name="company"
                placeholder="Company/Institution Name"
                className="border border-gray-300 rounded-lg p-3 w-full"
                value={formData.company}
                onChange={handleChange}
                required
              />
              <textarea
                name="comments"
                placeholder="Additional Comments"
                className="border border-gray-300 rounded-lg p-3 w-full"
                rows="4"
                value={formData.comments}
                onChange={handleChange}
              ></textarea>
              <button
                type="submit"
                className="bg-mainBlue text-white font-bold py-2 px-4 rounded-lg hover:bg-blue-700 transition duration-300"
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default SponsorsContact;